import axios from "./index";

class CashBoxApi {
  static GetCashBoxesList = (token) => {
    return axios.get(`${base}/cash_boxes`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static GetCashBoxById = (token, id) => {
    return axios.get(`${base}/cash_boxes_rd/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static CreateCashBox = (token, data) => {
    return axios.post(`${base}/cash_boxes`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static UpdateCashBox = (token, id, data) => {
    return axios.put(`${base}/cash_boxes_rd/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static DeleteCashBox = (token, id) => {
    return axios.delete(`${base}/cash_boxes_rd/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
}

let base = "accounts";

export default CashBoxApi;
